import { render, staticRenderFns } from "./IndexInBlock.vue?vue&type=template&id=2164412e&"
import script from "./IndexInBlock.vue?vue&type=script&lang=js&"
export * from "./IndexInBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports